module.exports = __webpack_public_path__ + "img/generic-avatar.5143c28a.png";